module.exports = __webpack_public_path__ + "media/evolve/assets/icons/atlas/video-task-c91e1b7cb595dbd5cc31e59af54ff92c.svg";